import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  companyTypeTitle: {
    defaultMessage: 'Company type',
    id: 'fWyFSI',
    description: 'Profile screen: company section (Тип компании)',
  },
  companyNameTitle: {
    defaultMessage: 'Company name',
    id: 'JJw82k',
    description: 'Profile screen: company section',
  },
  taxProfileTitle: {
    defaultMessage: 'Tax Profile',
    id: 'tax_profile_field_title',
    description: 'Profile screen: company section: Tax profile',
  },
  vatRegNoTitle: {
    defaultMessage: 'VAT REG NO',
    id: 'lYsQGl',
    description: 'Profile screen: company section',
  },
  regNumTitle: {
    defaultMessage: 'Company registration number',
    id: 'V2spUZ',
    description: 'Profile screen: company section: specific for GB',
  },
  innTitle: {
    defaultMessage: 'Company INN',
    id: '3n7aJS',
    description: 'Profile screen: company section: specific for RU',
  },
  kppTitle: {
    defaultMessage: 'Company KPP',
    id: 'zN+RTt',
    description: 'Profile screen: company section: specific for RU',
  },
  tradeLicenseNumberTitle: {
    defaultMessage: 'Trade License Number',
    id: '1xiSEM',
    description: 'Profile screen: company section: specific for UAE',
  },
  taxRegNoTitle: {
    defaultMessage: 'Tax Reg NO',
    id: 'yuKAnJ',
    description: 'Profile screen: company section: specific for UAE',
  },
  addressTitle: {
    defaultMessage: 'Company address',
    id: '/zotmy',
    description: 'Profile screen: company section',
  },
  title: {
    defaultMessage: 'Company info',
    id: 'ZKvp6f',
    description: 'Profile screen: subheader',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'global_action_edit',
    description: 'Profile screen: button text',
  },
});
